import React from 'react'
import CartItem from '../Components/CartItem/CartItem'

const cart = () => {
  return (
    <div className='my-4 mb-4'>
      <CartItem/>
    </div>
  )
}

export default cart
